import { countOrderFieldCharacters } from '@/lib/order-field-limits'
import { cn } from '@/lib/utils'

export type CharacterCountProps = {
  value?: string | null
  maxLength: number
  className?: string
}

export default function CharacterCount({ value, maxLength, className }: CharacterCountProps) {
  const characterCount = countOrderFieldCharacters(value)

  return (
    <div className={cn('flex justify-end', className)}>
      <span
        className={cn(
          'text-[11px] font-normal text-muted-foreground',
          characterCount >= maxLength && 'text-destructive'
        )}
      >
        {characterCount} / {maxLength}
      </span>
    </div>
  )
}
